/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type WebAppOnboardingQueryVariables = {};
export type WebAppOnboardingQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"WebAppOnboarding_viewer">;
    };
};
export type WebAppOnboardingQuery = {
    readonly response: WebAppOnboardingQueryResponse;
    readonly variables: WebAppOnboardingQueryVariables;
};



/*
query WebAppOnboardingQuery {
  viewer {
    ...WebAppOnboarding_viewer
    id
  }
}

fragment OnboardingNUXRenderer_org on Org {
  id
  experiments
  primaryOrgCalendar
}

fragment WebAppOnboarding_viewer on Viewer {
  user {
    flowStates(first: 1000000) {
      edges {
        node {
          id
          flowKey
          previousState
          current {
            id
            state
            percentComplete
            errorMessage
          }
          pending {
            id
            state
            percentComplete
            errorMessage
          }
        }
      }
    }
    orgs(first: 1000000) {
      edges {
        node {
          id
          experiments
          ...OnboardingNUXRenderer_org
        }
      }
    }
    id
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000000
        } as any
    ], v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v2 = [
        (v1 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "percentComplete",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "errorMessage",
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "WebAppOnboardingQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "WebAppOnboarding_viewer"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "WebAppOnboardingQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v0 /*: any*/),
                                    "concreteType": "FlowStateConnection",
                                    "kind": "LinkedField",
                                    "name": "flowStates",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "FlowStateEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "FlowState",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v1 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "flowKey",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "previousState",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "FlowStatus",
                                                            "kind": "LinkedField",
                                                            "name": "current",
                                                            "plural": false,
                                                            "selections": (v2 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "FlowStatus",
                                                            "kind": "LinkedField",
                                                            "name": "pending",
                                                            "plural": false,
                                                            "selections": (v2 /*: any*/),
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "flowStates(first:1000000)"
                                },
                                {
                                    "alias": null,
                                    "args": (v0 /*: any*/),
                                    "concreteType": "OrgConnection",
                                    "kind": "LinkedField",
                                    "name": "orgs",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Org",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v1 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "experiments",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "primaryOrgCalendar",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "orgs(first:1000000)"
                                },
                                (v1 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v1 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "10327fd35e6d4cac80206eca8841eff2",
            "id": null,
            "metadata": {},
            "name": "WebAppOnboardingQuery",
            "operationKind": "query",
            "text": "query WebAppOnboardingQuery {\n  viewer {\n    ...WebAppOnboarding_viewer\n    id\n  }\n}\n\nfragment OnboardingNUXRenderer_org on Org {\n  id\n  experiments\n  primaryOrgCalendar\n}\n\nfragment WebAppOnboarding_viewer on Viewer {\n  user {\n    flowStates(first: 1000000) {\n      edges {\n        node {\n          id\n          flowKey\n          previousState\n          current {\n            id\n            state\n            percentComplete\n            errorMessage\n          }\n          pending {\n            id\n            state\n            percentComplete\n            errorMessage\n          }\n        }\n      }\n    }\n    orgs(first: 1000000) {\n      edges {\n        node {\n          id\n          experiments\n          ...OnboardingNUXRenderer_org\n        }\n      }\n    }\n    id\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'e45b3eddfe48735cb6701e3778e25d30';
export default node;
